
export const baseUrl="https://ingredientiq.ai/web/";

export const showConsole = false;
